// Recognises errors raised by a script the *visitor's* browser injected into our
// page — a browser extension, a userscript manager — rather than by this app.
//
// Honeybadger's own `ignoreBrowserExtensionErrors` option is not enough: it only
// looks at the top frame, and it only knows the `*-extension://` schemes. Safari
// names every injected user script `user-script:<n>` and happily puts a native
// frame on top, so an extension calling `postMessage` on a closed port arrives as
//
//   postMessage@[native code]
//   @user-script:2:24:30
//   @user-script:5:3:48
//
// which that option passes straight through. These are unreproducible and
// unfixable for us, and they drown out real errors.

// A frame from an injected script.
const EXTENSION_FRAME =
  /^(user-script:|webkit-masked-url:|(chrome|moz|safari|safari-web)-extension:\/\/)/

// A frame the browser cannot attribute to a file. It says nothing about who
// raised the error, so it neither convicts nor exonerates a stack.
const ANONYMOUS_FRAME = /^(\[native code\]|<anonymous>|native|debugger eval code)?$/

// `backtrace` is the parsed stack Honeybadger hands to a beforeNotify handler.
// A stack with even one of our own frames is NOT an extension error — our code is
// then in the call path and the bug may well be ours. A stack we cannot attribute
// at all (no frames, or nothing but native frames) is kept too, for the same
// reason: dropping errors we cannot place would hide our own.
export const raisedByBrowserExtension = (backtrace) => {
  if (!Array.isArray(backtrace) || backtrace.length === 0) {
    return false
  }

  const files = backtrace.map((frame) => (frame && frame.file) || "")

  return (
    files.some((file) => EXTENSION_FRAME.test(file)) &&
    files.every((file) => EXTENSION_FRAME.test(file) || ANONYMOUS_FRAME.test(file))
  )
}
